import { createContext, useContext } from 'react';

type UndoRedoContext = {
	undo: () => void;
	redo: () => void;
	addUndoState: () => void;
};

const context = createContext<UndoRedoContext | null>(null);

export function useUndoRedoContext(): UndoRedoContext {
	const contextValue = useContext(context);

	if (contextValue === null) {
		throw new Error('useUndoRedoContext must be used within a UndoRedoContextProvider');
	}

	return contextValue;
}

export const UndoRedoContextConsumer = context.Consumer;
export const UndoRedoContextProvider = context.Provider;
